// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageLocationStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type PlanPackageLocationStepQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, roomLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, isInsideMapsRoom?: boolean | null | undefined, insideMapsRoomOrder?: number | null | undefined, roomNumber?: number | null | undefined, marketingName: string, relatedTakeoffLineItemsCount: number, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, level?: { __typename?: 'Location', id: string, name: string } | null | undefined, roomType?: { __typename?: 'RoomType', id: string } | null | undefined, location: { __typename?: 'Location', id: string, name: string } }> }, levels: Array<{ __typename?: 'Location', id: string, name: string, parent?: { __typename?: 'Location', id: string } | null | undefined }> };

export type BulkSaveRplsMutationVariables = Types.Exact<{
  inputs: Array<Types.SaveReadyPlanLocationInput> | Types.SaveReadyPlanLocationInput;
}>;


export type BulkSaveRplsMutation = { __typename?: 'Mutation', saveReadyPlanLocations: { __typename?: 'SaveReadyPlanLocationBulkResult', readyPlanLocations: Array<{ __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, name: string } }>, affectedTlis: Array<{ __typename?: 'TakeoffLineItem', id: string, location: { __typename?: 'Location', id: string, name: string, path?: string | null | undefined, pathAsCode?: string | null | undefined, displayLocationPath: string } }> } };

export type RoomTypeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RoomTypeQuery = { __typename?: 'Query', roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };


export const PlanPackageLocationStepDocument = gql`
    query PlanPackageLocationStep($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    roomLocations {
      id
      isInsideMapsRoom
      insideMapsRoomOrder
      roomNumber
      marketingName
      canDelete {
        ...PotentialOperationDetails
      }
      level {
        id
        name
      }
      roomType {
        id
      }
      location {
        id
        name
      }
      relatedTakeoffLineItemsCount
    }
  }
  levels: locations(filter: {type: [LEVEL], version: [2]}) {
    id
    name
    parent {
      id
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}`;

/**
 * __usePlanPackageLocationStepQuery__
 *
 * To run a query within a React component, call `usePlanPackageLocationStepQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageLocationStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageLocationStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePlanPackageLocationStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables> & ({ variables: PlanPackageLocationStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>(PlanPackageLocationStepDocument, options);
      }
export function usePlanPackageLocationStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>(PlanPackageLocationStepDocument, options);
        }
// @ts-ignore
export function usePlanPackageLocationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>;
export function usePlanPackageLocationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageLocationStepQuery | undefined, PlanPackageLocationStepQueryVariables>;
export function usePlanPackageLocationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>(PlanPackageLocationStepDocument, options);
        }
export type PlanPackageLocationStepQueryHookResult = ReturnType<typeof usePlanPackageLocationStepQuery>;
export type PlanPackageLocationStepLazyQueryHookResult = ReturnType<typeof usePlanPackageLocationStepLazyQuery>;
export type PlanPackageLocationStepSuspenseQueryHookResult = ReturnType<typeof usePlanPackageLocationStepSuspenseQuery>;
export type PlanPackageLocationStepQueryResult = ApolloReactCommon.QueryResult<PlanPackageLocationStepQuery, PlanPackageLocationStepQueryVariables>;
export const BulkSaveRplsDocument = gql`
    mutation BulkSaveRpls($inputs: [SaveReadyPlanLocationInput!]!) {
  saveReadyPlanLocations(inputs: $inputs) {
    readyPlanLocations {
      id
      location {
        id
        name
      }
    }
    affectedTlis {
      id
      location {
        id
        name
        path
        pathAsCode
        displayLocationPath
      }
    }
  }
}
    `;

/**
 * __useBulkSaveRplsMutation__
 *
 * To run a mutation, you first call `useBulkSaveRplsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSaveRplsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSaveRplsMutation, { data, loading, error }] = useBulkSaveRplsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useBulkSaveRplsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BulkSaveRplsMutation, BulkSaveRplsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BulkSaveRplsMutation, BulkSaveRplsMutationVariables>(BulkSaveRplsDocument, options);
      }
export type BulkSaveRplsMutationHookResult = ReturnType<typeof useBulkSaveRplsMutation>;
export type BulkSaveRplsMutationResult = ApolloReactCommon.MutationResult<BulkSaveRplsMutation>;
export const RoomTypeDocument = gql`
    query RoomType {
  roomTypes {
    id
    name
  }
}
    `;

/**
 * __useRoomTypeQuery__
 *
 * To run a query within a React component, call `useRoomTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
      }
export function useRoomTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
        }
// @ts-ignore
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RoomTypeQuery, RoomTypeQueryVariables>;
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RoomTypeQuery | undefined, RoomTypeQueryVariables>;
export function useRoomTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RoomTypeQuery, RoomTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RoomTypeQuery, RoomTypeQueryVariables>(RoomTypeDocument, options);
        }
export type RoomTypeQueryHookResult = ReturnType<typeof useRoomTypeQuery>;
export type RoomTypeLazyQueryHookResult = ReturnType<typeof useRoomTypeLazyQuery>;
export type RoomTypeSuspenseQueryHookResult = ReturnType<typeof useRoomTypeSuspenseQuery>;
export type RoomTypeQueryResult = ApolloReactCommon.QueryResult<RoomTypeQuery, RoomTypeQueryVariables>;